import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { getAllCategorys } from "../../../redux/actions/categories";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class MerchantPayoutByOffer extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'MERCHANT_PAYOUT_BY_OFFER',
      path: ["Home", "Merchant Payout By Offer"],
      links: ["home", "report/payout-by-offer"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      historyPopup: false, 
      payoutHistory: '',
      offerIDs: '',
      merchantIDs: '',
      paymentTermID: '',
      payoutList: '',
      catData: '',
      catID: '',
      merchantTypeID: '',
      dealType: '',
      totalRecords: 0,
      based_on:'offer_date',
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    if(e.target.name == 'dealType'){
      this.props.getAllCategorys({categoryType: e.target.value, page:0});
      this.setState({catID: ''});
    }
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          catID:  this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          dealType: this.state.dealType,
          based_on: this.state.based_on,
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format(),
          catID:  this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          dealType: this.state.dealType,
          based_on: this.state.based_on,
        };
      }

      this.props.getReport(formData, 'report/merchant-payout-by-offer');
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'});
        this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD'), dealType:'offer'}, 'report/merchant-payout-by-offer');
        this.props.getAllCategorys({categoryType: 'offer', page:0});
      }else{
        this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD')}, 'report/merchant-payout-by-offer');
        this.props.getAllCategorys({categoryType: this.state.dealType, page:0});
      }
    }
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ totalRecords: nextProps.reportData.total_record });
        this.setState({ reportData: nextProps.reportData });
        this.handleExport(nextProps.reportData);
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        isLoading = "false";
        this.setState({ catData: nextProps.catData.data });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }


  }

  handleExport = data => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    let setDate = (this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Data up to the date: ' + setDate,
      ],
      [
        'Total Records : ' + this.state.totalRecords,
      ],
      [
        'Type',
        'Merchant Name',
        'Market',
        'Offer ID',
        'Offer Name',
        'Offer Price',
        'Start Date',
        'End Date',
        'Company ID', 
        'Legal Name',
        'Payment Terms Name',  
        'Gross Sales',
        'Refund Amount',
        'Merchant Shipping Amount',
        'Adjusted Gross Sales', 
        'Quanity Purchased ',  
        'Merchant Commission %',
        'Credit Card Fee',
        'Taxes',
        'Net Payout', 
        'Final Net Payout', 
        'Vouchers',
        'Customer Spend', 
      ]
    ];

    {data &&
      data.data.map((payData, payIndex) => 
        csvData.push([
          (payData.proposal_type == '10') ? 'Product' : (payData.proposal_type == '11') ? 'Auction' : 'Offer',
          payData.merchantName,
          payData.title,
          payData.offerID,
          payData.offerName,
          payData.offer_price,
          payData.startDate,
          payData.endDate,
          payData.siteID, 
          payData.legalName,
          payData.termName, 
          payData.grossSale,
          payData.amount_refunded,
          payData.shipping_amount_merchant,
          payData.adjustedGrossSale, 
          payData.quantityPurchased , 
          payData.merchant_commission,
          payData.cc_sales,
          payData.tax_amount,
          payData.netPayout, 
          payData.final_payout, 
          payData.vouchers,
          payData.customerSpendAmt,
        ])
      )
    }

    this.setState({ csvData: csvData });
  };

  render() {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
      dateRange = this.state.startDateRange;
    }
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Merchant Payout By Offer</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup controlId="based_on">
                    <ControlLabel>Report By</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.based_onError }}
                      name="based_on"
                      onChange={this.handleChange}
                      value={this.state.based_on}
                    >
                      <option value="offer_date">Based on Offer Date</option>
                      <option value="transaction_date">Based on Transaction Date</option> 
                    </FormControl>
                  </FormGroup>
                </Col>

                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col> 
                <Col md={3} xs={12}>
                    <FormGroup controlId="formParentID">
                      <ControlLabel>Deal Type</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="dealType"
                        onChange={this.handleChange}
                        placeholder="select"
                        value={this.state.dealType}
                      >
                        <option value="">All</option>
                        <option value="offer">Offer</option>
                        <option value="products">Products</option>
                        <option value="auction">Auction</option>
                      </FormControl>
                    </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Category</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.catIDError }}
                      name="catID"
                      onChange={this.handleChange}
                      value={this.state.catID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.catData) &&
                        this.state.catData.map((type, index) => (
                          <option key={type.catID} value={type.catID}>
                            {type.catName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>  
                <Col md={3} xs={12}>
                    <FormGroup controlId="formParentID">
                      <ControlLabel>Proposal Type</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="merchantTypeID"
                        onChange={this.handleChange}
                        placeholder="select"
                        value={this.state.merchantTypeID}
                      >
                        <option value="">All</option>
                        <option value="1">Standard Merchant</option>
                        <option value="2">Premium Merchant</option>
                        <option value="3">Products</option>
                        <option value="4">Travel</option>
                        <option value="5">Events</option>
                        <option value="6">Coupon Offer</option>
                        <option value="7">Affiliate Offer</option> 
                        <option value="8">Gift Card Vouchers</option>
                        <option value="9">Recurring Billing</option> 
                        <option value="10">Product Deal</option> 
                        <option value="11">Auction</option>
                      </FormControl>
                    </FormGroup>
                  </Col>          
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"merchantpayoutpaid-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th colSpan="20">Data up to the date: {(this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY')}</th>
                </tr>
                <tr>
                  <th colSpan="20">Total Records : {this.state.totalRecords}</th>
                </tr>
                <tr>
                  <th>Type</th>
                  <th>Merchant Name</th>
                  <th>Market</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Offer Price</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Company ID</th> 
                  <th>Legal Name</th>
                  <th>Payment Terms Name</th> 
                  <th>Gross Sales</th>
                  <th>Refund Amount</th>
                  <th>Merchant Shipping Amount</th>
                  <th>Adjusted Gross Sales</th> 
                  <th>Quanity Purchased </th>   
                  <th>Merchant Commission %</th>
                  <th>Credit Card Fee</th>
                  <th>Taxes</th> 
                  <th>Net Payout</th> 
                  <th>Final Net Payout</th>  
                  <th>Vouchers</th>
                  <th>Customer Spend</th> 
                </tr>
              </thead>
              <tbody>
              {this.state.reportData ?
                this.state.reportData.data.map((payData, payIndex) =>
                  <tr key={payData.offerID + payIndex}>
                    <td>{(payData.proposal_type == '10') ? 'Product' : (payData.proposal_type == '11') ? 'Auction' : 'Offer'}</td>
                    <td>{payData.merchantName}</td>
                    <td>{payData.title}</td>
                    <td>{payData.offerID}</td>
                    <td>{payData.offerName}</td>
                    <td>{payData.offer_price}</td>
                    <td>{payData.startDate}</td>
                    <td>{payData.endDate}</td>
                    <td>{payData.siteID}</td> 
                    <td>{payData.legalName}</td>
                    <td>{payData.termName}</td>
                    <td>{payData.grossSale}</td>
                    <td>{payData.amount_refunded}</td>
                    <td>{payData.shipping_amount_merchant}</td>
                    <td>{payData.adjustedGrossSale}</td> 
                    <td>{payData.quantityPurchased }</td> 
                    <td>{payData.merchant_commission}</td>
                    <td>{payData.cc_sales}</td>
                    <td>{payData.tax_amount}</td> 
                    <td>{payData.netPayout}</td>  
                    <td>{payData.final_payout}</td>  
                    <td>{payData.vouchers}</td>
                    <td>{payData.customerSpendAmt}</td>
                  </tr>
                )
                :
                <tr><td colSpan="20">Data Not Found</td></tr>
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
    catData: state.categoryReducer.catData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
    getAllCategorys,
  })
)(MerchantPayoutByOffer);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/MerchantPayoutByOffer.js